<template>
	<div class="list-container column">
		<div class="title-container">
			<div class="title">{{ $t('protectionslist.title') }}</div>
			<div class="dash-select" :class="{ mobile: isMobile }">
				<v-select
					class="panel-select dashboard"
					:value="selectedInfo"
					:options="sortedInfos"
					:placeholder="$t('protectionslist.select_floor')"
					:allowEmpty="false"
					:internalSearch="true"
					:showLabels="false"
					:custom-label="selectLabel"
					@input="selectInfo"
					label="floorName"
					track-by="id"
				>
					<span slot="noResult">{{ $t('protectionslist.no_results') }}</span>
					<span
						slot="caret"
						slot-scope="{ toggle }"
						class="caret"
						@mousedown.prevent.stop="toggle()"
					><i class="fas fa-caret-down caret-inner"></i
					></span>
				</v-select>
			</div>
		</div>
		<div class="panel-list-header" :class="{ mobile: isMobile }">
			<div class="panel-filler-icon" />
			<div class="panel-header-item pos" :class="{ mobile: isMobile }">
				{{ isMobile ? $t('protectionslist.pos') : $t('protectionslist.position_number') }}
			</div>
			<div class="panel-header-item" v-if="!isMobile">{{ $t('protectionslist.type') }}</div>
			<div class="panel-header-item placement">{{ $t('protectionslist.placement') }}</div>
			<div class="panel-header-item flaw-item" v-if="!isMobile">{{ $t('protectionslist.flaw') }}</div>
			<div class="panel-filler-special" :class="{ mobile: isMobile }" />
		</div>
		<div
			class="panel-list no-hover"
			v-for="(fireProtection, index) in items"
			:key="fireProtection.id || fireProtection.clientKey || index"
			:class="[{ mobile: isMobile }, isDone(fireProtection)]"
		>
			<div class="panel-list-item special">
				<div
					class="fireprotection-icon"
					:class="[{ mobile: isMobile }, getType(fireProtection.inventoryType)?.icon]"
					@click="openInstruction(fireProtection)"
				></div>
			</div>
			<p class="panel-list-item pos" :class="{ mobile: isMobile }">
				{{ fireProtection.positionNumber }}
			</p>
			<div class="panel-list-item" v-if="!isMobile">
				{{ displayType(fireProtection) }}
			</div>

			<div class="panel-list-item placement">
				{{ fireProtection.placementDescription }}
			</div>
			<div class="panel-list-item flaw-item" v-if="!isMobile">
				{{ getFlaw(fireProtection) }}
			</div>
			<div class="button-container" v-if="!isMobile">
				<div class="instruction-icon">
					<i class="far fa-question-circle" />
					<span class="instruction-tooltip" v-if="fireProtection.instruction">
						{{ tInstruction(fireProtection.instruction) }}
					</span>
				</div>
				<div class="field has-addons">
					<div class="control">
						<button
							class="button is-success"
							:disabled="disableOk(fireProtection)"
							@click="noFlaw(fireProtection)"
						>
							Ok
						</button>
					</div>
					<div class="control">
						<button class="button" @click="addFlaw(index, 'row')">
							{{ $t('protectionslist.flaw') }}
						</button>
					</div>
				</div>
			</div>
			<div class="mobile-buttons" v-else>
				<button
					class="button is-success"
					:disabled="disableOk(fireProtection)"
					@click="noFlaw(fireProtection)"
				>
					{{ $t('protectionslist.ok_button') }}
				</button>
				<button class="button" @click="addFlaw(index, 'row')">{{ $t('protectionslist.flaw') }}</button>
			</div>
		</div>
		<div class="title-container flaw-title">
			<div class="title">{{ $t('protectionslist.loose_flaws_title') }}</div>
			<button
				class="button is-info"
				:class="{ mobile: isMobile }"
				@click="addFlaw(-1, 'loose')"
			>
				<span class="icon"><i class="fas fa-plus"/></span>
				<span>{{ $t('protectionslist.new_flaw_button') }}</span>
			</button>
		</div>
		<div></div>
		<div class="panel-list-header" :class="{ mobile: isMobile }">
			<div class="panel-filler-icon" />
			<div class="panel-header-item flaw-item">{{ $t('protectionslist.flaw') }}</div>
			<div class="panel-header-item flaw-item" v-if="!isMobile">
				{{ $t('protectionslist.description') }}
			</div>
			<div class="panel-filler-special" :class="{ mobile: isMobile }" />
		</div>
		<div
			class="panel-list no-hover flaw-list"
			v-for="(flaw, index) in flaws"
			:key="flaw.id || flaw.clientKey || index"
			:class="[{ mobile: isMobile }, isDone(flaw)]"
		>
			<div class="panel-list-item special">
				<div class="fireprotection-icon flaw"></div>
			</div>
			<div class="panel-list-item flaw-item">
				{{ flaw.name }}
			</div>
			<div class="panel-list-item flaw-item" v-if="!isMobile">
				{{ flaw.description }}
			</div>
			<div class="button-container flaw">
				<div class="field has-addons">
					<div class="control">
						<button class="button" @click="addFlaw(index, 'loose')">
							{{ $t('protectionslist.flaw') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="flaws.length == 0">
			<p class="panel-list-item">{{ $t('protectionslist.no_results') }}</p>
		</div>
		<InstructionModal
			v-if="showInstruction"
			:item="selectedItem"
			@close="closeInstruction"
		/>
	</div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';
import InstructionModal from './InstructionModal.vue';
import { mapGetters, mapMutations } from 'vuex';
export default {
	mixins: [iconMixin],
	components: {
		InstructionModal
	},
	props: {
		infos: Array
	},
	data: () => ({
		selectedItem: {},
		showInstruction: false
	}),
	computed: {
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('roundHistoryStore', ['activeRound']),

		
		sortedInfos() {
			const arr = Array.isArray(this.infos) ? this.infos : [];
			return [...arr].sort((a, b) => new Date(a.floorCreated) - new Date(b.floorCreated));
		},
		selectedInfoId() {
			const idx = this.activeRound?.currentInfo;
			if (idx !== null && idx !== undefined && this.infos?.[idx]?.id) {
				return this.infos[idx].id;
			}
			return this.activeRound?.currentInfoId ?? this.sortedInfos?.[0]?.id ?? null;
		},

		// Always get the current info from the latest prop value
		selectedInfo() {
			return this.sortedInfos.find(i => i.id === this.selectedInfoId) || {};
		},
		items() {
			const items = this.selectedInfo?.roundHistoryItems || [];
			return items.filter(i =>
				i &&
				i.id &&                     
				i.positionNumber != null &&
				i.inventoryType              
			);
		},
		flaws() {
			const list = this.selectedInfo?.flaws || [];
			return list.filter(f => !f.roundHistoryItemId);
		}
	},
	methods: {
		...mapMutations('roundHistoryStore', ['SET_ACTIVEROUND']),

		deepClone(obj) { return JSON.parse(JSON.stringify(obj)); },
		selectLabel({ buildingName, floorName }) {
			return `${buildingName} - ${floorName}`;
		},
		selectInfo(info) {
			const selectedIndex = (this.infos || []).findIndex(i => i.id === info.id);
			if (selectedIndex === -1) return;

			const roundData = {
				...this.activeRound,
				currentInfo: selectedIndex,
				currentInfoId: info.id
			};
			this.SET_ACTIVEROUND(roundData);
			this.$emit('update');
		},
		flawAdded(item) {
			const roundData = JSON.parse(JSON.stringify(this.activeRound));
			const info = (roundData?.infos || []).find(i => i.id === this.selectedInfoId);
			if (!info || !Array.isArray(info.roundHistoryItems)) return;

			const idx = info.roundHistoryItems.findIndex(i => i.id === item.id);
			if (idx === -1) return;

			info.roundHistoryItems[idx] = item;
			this.$emit('saveState', roundData);
		},

		isDone(item) {
			if (!item) return;

			const flaws = Array.isArray(item.flaws) ? item.flaws : [];
			const hasOpen = flaws.some(f => !f?.done);

			const checkedThisRound = !!item.controlled || !!item.continueWithoutAdding;

			if (checkedThisRound) return hasOpen ? "not-done" : "done";

			if (hasOpen) {
				return this.hasOpenFlawFromPreviousRound(item) ? "ignored-not-done" : "not-done";
			}

			if (!item.controlled && flaws.length === 0) return;

			return "done";
		},
		toMs(d) {
			if (!d) return null;

			if (d instanceof Date) {
				const t = d.getTime();
				return Number.isNaN(t) ? null : t;
			}

			let s = String(d).trim();
			if (!s) return null;

			s = s.replace(/(\.\d{3})\d+/, "$1");

			const hasTz = /([zZ]|[+\-]\d{2}:\d{2})$/.test(s);
			if (!hasTz) s += "Z";

			const t = Date.parse(s);
			return Number.isNaN(t) ? null : t;
		},
		hasOpenFlawFromPreviousRound(item) {
			const flaws = Array.isArray(item?.flaws) ? item.flaws : [];
			const open = [...flaws].reverse().find(f => !f?.done);
			if (!open) return false;

			const roundStart = this.toMs(this.activeRound?.created);
			const flawCreated = this.toMs(open?.created);

			if (roundStart == null || flawCreated == null) return true;

			return flawCreated < roundStart;
		},

		noFlaw(item) {
			const roundData = JSON.parse(JSON.stringify(this.activeRound));
			const info = (roundData?.infos || []).find(i => i.id === this.selectedInfoId);
			if (!info || !Array.isArray(info.roundHistoryItems)) return;

			const idx = info.roundHistoryItems.findIndex(i => i.id === item.id);
			if (idx === -1) return;

			const updated = { ...info.roundHistoryItems[idx] };
			updated.controlled = this.setDate ? this.setDate() : new Date();
			updated.userName = roundData.userName;

			info.roundHistoryItems[idx] = updated;

			this.$emit('saveState', roundData);
		},
		addFlaw(index, origin) {
			const fp = (origin === 'row' && index >= 0) ? this.items[index] : null;

			this.$emit('addFlaw', index, origin, {
				infoId: this.selectedInfoId,
				rowItemId: fp?.id || null,          // ✅ important
				mapItemId: fp?.mapItemId || null,   // optional if you use it elsewhere
				prefCategoryId: fp?.flawCategoryId || fp?.flawCategory?.id || null,
				prefCategoryKey: (this.normalizeTypeBare && fp?.inventoryType)
				? this.normalizeTypeBare(fp.inventoryType)
				: null,
			});
		},
		getFlaw(item) {
			const flaws = Array.isArray(item?.flaws) ? item.flaws : [];

			const open = [...flaws].reverse().find(f => !f?.done);
			if (open) return open.name || '';

			const last = flaws.length ? flaws[flaws.length - 1] : null;
			if (last?.done) return `${this.$t('protectionslist.fixed')} - ${last.name}`;

			return '';
		},

		disableOk(item) {
			const flaws = Array.isArray(item?.flaws) ? item.flaws : [];
			return flaws.some(f => !f?.done); // disable if ANY open flaw exists
		},
		
		openInstruction(item) {
			if (!this.isMobile) return;

			this.selectedItem = item;
			this.showInstruction = true;
		},
		closeInstruction() {
			this.showInstruction = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";
.title-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &.flaw-title {
    margin-top: 1rem;
    .button {
      margin-top: -0.5rem;
      &.mobile {
        margin-right: 0.5rem;
        margin-left: auto;
        margin-top: -0.2rem;
        margin-bottom: 0.5rem;
      }
    }
  }
}
.dash-select {
  margin-top: -0.5rem;
  &.mobile {
    margin-right: 0.5rem;
    margin-left: auto;
    margin-top: -0.5rem;
    margin-bottom: 0.5rem;
  }
}
.button {
  border-radius: 2px;
}
.panel-list-item.special {
  margin-right: 5px;
  max-width: 40px;
  position: relative;
}
.panel-list-item,
.panel-header-item {
  flex: 2;
  &.placement,
  &.flaw-item {
    flex: 3;
  }
}
.panel-list,
.panel-list-header {
  &.mobile {
    padding: 8px;
  }
}
.panel-list {
  &.done {
    background-color: #cdebcd !important;
    &:nth-child(odd) {
      background-color: #c3e0c3 !important;
    }
  }

  &.not-done {
    background-color: #f0cbcb !important;
    &:nth-child(odd) {
      background-color: #e9b9b9 !important;
    }
  }

  &.ignored-not-done {
	background-color: rgba(255, 123, 0, .4);

	&:nth-child(odd) {
		background-color: rgba(255, 123, 0, .25);
	}
  }

  &.flaw-list {
    padding-top: 1rem;
  }
}
.fireprotection-icon {
  background-color: transparent;
  top: -7px;
  width: 30px;
  height: 30px;
  z-index: 2;
  position: absolute;
  background-size: contain;
  &.mobile {
    transform: translateY(30px);
  }
}
.panel-filler-special {
  margin-right: 120px;
  &.mobile {
    margin-right: 65px;
  }
}
.mobile-buttons {
  max-width: 65px;
  margin-right: 0;
  .button {
    width: 65px;
  }
}
.panel-list-item.pos,
.panel-header-item.pos {
  max-width: 80px;
  &.mobile {
    max-width: 40px;
  }
}
.button-container {
  margin-top: -16px;
  position: relative;
  margin-right: 120px;
  &.flaw {
    margin-top: -20px;
    margin-right: 83px;
    margin-left: 55px;
  }
  .field {
    position: absolute;
    top: 8px;
  }
  .instruction-icon {
    position: absolute;
    display: flex;
    left: -2.5rem;
    top: 0.5rem;
    height: 100%;
    padding: 0 0.5rem;
    &:hover {
      i {
        color: $info-active;
      }
      .instruction-tooltip {
        visibility: visible;
      }
    }
    > i {
      margin: auto;
    }
    .instruction-tooltip {
      visibility: hidden;
      background: #f7f7f7;
      border: 1px solid grey;
      border-radius: 4px;
      min-width: 360px;
      position: absolute;
      padding: 5px;
      right: 105%;
      top: -5px;
      white-space: pre-wrap;
      box-shadow: 5px 5px 5px $shadow-color;
    }
  }
}
</style>

<style lang="scss">
.multiselect.panel-select.dashboard {
  min-width: 220px;
  max-width: 220px;
  .caret {
    background-color: #fcfcfc;
  }
  .multiselect__tags {
    background-color: white;

    .multiselect__single,
    .multiselect__input {
      background-color: white;
    }
  }
  .multiselect__content {
    background: white;
  }
}
</style>


